import { onMounted, watch, computed } from "vue"
import { useStore } from "vuex"
import { getTeamParticipantEmails } from "foundation/js/teamParticipantUtils"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'


export default {
    name: "HoldOprettelseKvittering",
    props:{
        teamId: {
            type: String,
            required: false
        }
    },
    setup(props){
        const store = useStore()

        const previousHoldkode = new URLSearchParams(document.location.search).get('previousHoldkode')

        let listOfRecipients = computed(() => 
            previousHoldkode
                ? getTeamParticipantEmails(store.state.stafet.teamParticipantDetails)
                : ''
        )
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active

        onMounted(() => {
            store.dispatch('stafet/getTeamParticipantDetails',{
                teamId: previousHoldkode
            })

            let first = document.querySelector('.kb-hold-oprettelse-kvittering [data-order="first"]') ?? document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback({
                opening(){
                    first.focus()
                }
            }, { persistent: true })  

            if (!gtmActive) return

            const holdKode = new URLSearchParams(document.location.search).get(
                'holdKode'
            )            
            window.dataLayer = window.dataLayer || []
            dataLayer.push({ ecommerce: null })
            var event = {
                event: 'hold_oprettelse',
                holdKode: holdKode
            }
            dataLayer.push(event)          
        })

        const openGenoprettelseMailudsendelseOverlay = function(e) {
            store.dispatch('main/closePageOverlay')

            store.commit('main/set_page_overlay_content_data', { type: "Genoprettelse" })
            store.dispatch('main/openPageOverlay', {
                overlayContent: "StafetMailEditorOverlay",
                returnTarget: e.currentTarget
            })
        }
        
        return {
            listOfRecipients,
            openGenoprettelseMailudsendelseOverlay,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'HoldOprettelseKvittering',
                    labelKey
                })
        }
    }
}